<template>
  <div class="collection">
    <div class="collect">
      <header v-if="!empty">
        <p v-if="!editor" @click="editorClick()">编辑</p>
        <p v-else @click="editorClick()">取消</p>
      </header>
      <!--<scroller :on-infinite="infinite" :on-refresh="refresh" :noDataText="noDataText" ref="my_scroller">-->
      <Scroller :is-refresh-data.sync="refresh"
                :is-loading-data.sync="loading"
                :is-finished-data.sync="finished"
                :no-data-text-data.sync="noDataText"
                @on-infinite="onInfinite"
                @on-refresh="onRefresh"
                class="my_scroller"
                ref="my_scroller"
                v-if="!empty"

      >
        <ul>
          <li v-for="(item, index) of list" :key="index" :style="lisStyle">
            <b class="check" v-if="editor">
              <input :id="'checkbox'+index" @click="check(index)" type="checkbox" v-model="checkbox" :value="index" :checked='item.isChecked'>
              <label :for="'checkbox'+index">
                <i :class="{'on':item.isChecked}"></i>
              </label>
            </b>
            <div class="liContent">
              <div class="content" @click="proDetail(item)" ref="content"  @touchstart="start($event,index)" @touchmove="move($event,index)" @touchend="end($event,index)">
                <img v-lazy="item.img_path">
                <div class="detail">
                  <p>
                    {{item.name}}
                  </p>
                  <b>已售{{parseFloat(item.sales_num) / 10000 >= 1 ? (parseInt(parseInt(item.sales_num) / 100) / 100).toFixed(2) + 'w' : item.sales_num}}</b>
                  <span class="nowPrice" v-if="!item.sales_price">
                    <sub>¥</sub>
                    <i>0</i>
                    <sup>.00</sup>
                  </span>
                  <span class="nowPrice" v-if="item.sales_price">
                    <sub>¥</sub>
                    <i>{{String(parseFloat(item.sales_price).toFixed(2)).slice(0, String(parseFloat(item.sales_price).toFixed(2)).indexOf('.'))}}</i>
                    <sup>{{String(parseFloat(item.sales_price).toFixed(2)).slice(String(parseFloat(item.sales_price).toFixed(2)).indexOf('.'), String(parseFloat(item.sales_price).toFixed(2)).length)}}</sup>
                  </span>
                </div>
              </div>
              <p ref="p" @click="deleteClick($event, item, index)">删除</p>
            </div>
          </li>
        </ul>
      </Scroller>
      <!--</scroller>-->
      <footer class="footerIOS" v-if="editor">
        <b class="check">
          <input id="'checkboxAll" @click="checkAllClick" type="checkbox" v-model="checkboxAll" value="all" :checked='checkedAll'>
          <label for="'checkboxAll">
            <i :class="{'on':checkedAll}"></i>
            <div>全选</div>
          </label>
          <div class="clear"></div>
        </b>
        <button class="btnDel" v-if="!deleteBool">删除</button>
        <button class="btnDel delete" v-else @click="deleteClick()">删除</button>
      </footer>
    </div>
    <div ref="empty" class="empty" v-if="list && list.length <= 0 && (productlist && productlist.length <= 0)"  style="display: none;height: 100%;">
      <empty :path="'noCollect'"></empty>
    </div>
    <div ref="empty" class="empty" v-if="list && list.length <= 0 && (productlist && productlist.length > 0)" style="display: none">
      <img src="../../assets/images/nocollect.png">
      <p>您还没有收藏任何商品哦～</p>
      <button @click="stroll"
        style="
        padding: 0.08rem 0.27rem;
        border: 1px solid #FC0324;
        border-radius: 0.2rem;
        font-size:0.14rem;
        color:#FC0324;
        display: block;
        background: none;
        outline: none;
        margin: 0.16rem auto 0;"
      >去逛逛</button>
    </div>
    <div ref="recommend" v-if="list && list.length <= 0 && (productlist && productlist.length > 0)" style="padding: 0.15rem 0.11rem 0.11rem;background: #fff;display: none">
      <product-list :title="title" :productlist="productlist"></product-list>
    </div>
  </div>
</template>

<script>
import productList from '../common/productList'
import empty from '../emptypage/empty'
import { customRequestAjax } from '@/axiosApi'
import Scroller from '../common/Scroller'
import { isWeixin, fenxiang } from '../../assets/common/js/config'

export default {
  name: 'collection',
  data () {
    return {
      list: [],
      productlist: [],
      title: '为你推荐',
      checkbox: [],
      empty: false, // 判断header DOM元素是否显示
      isChooseProduct: [],
      editor: false,
      checkedAll: false,
      checkboxAll: [],
      deleteBool: false,
      lisStyle: {},
      x: null,
      p: null,
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——'
    }
  },
  components: {
    productList,
    empty,
    Scroller
  },
  watch: {
    editor (n) {
      // console.log(n)
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'collection'})
    }
    // this.nowPage = 1
    // this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/') { // 当前页面刷新不需要切换位置
      next(vm => {})
    } else {
      next(vm => {
        if (from.path != '/productdetail') Object.assign(vm.$data, vm.$options.data())
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (to.path != '/productdetail') this.loading = true
    next()
  },
  methods: {
    getData: function (fn) {
      var url = 'Wxmall/Collection/getCollectionList?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      var recommendUrl = 'Wxmall/Item/getRecommendByCollection'
      var that = this
      customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          if (that.nowPage === 1) {
            that.list = res.data.itemlist
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.itemlist)
          }
          that.loading = false
          if (res.data.itemlist.length < that.pagesize) {
            that.finished = true
            if (that.list && that.list.length <= 0) {
              that.empty = true
              customRequestAjax(recommendUrl).then(res => {
                if (res.data.code === 200) {
                  if (res.data.itemlist.length > 0) {
                    that.productlist = res.data.itemlist
                    setTimeout(function () {
                      that.$refs.empty.style.display = 'block'
                      that.$refs.recommend.style.display = 'block'
                    })
                  } else {
                    setTimeout(function () {
                      that.$refs.empty.style.display = 'block'
                    })
                  }
                }
              })
            }
          } else {
            that.finished = false
          }
          if (typeof (fn) === 'function') {
            fn()
          }
        }
      })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      // this.list = []
      var that = this
      this.getData(function () {
        that.checkAllClick(false)
        that.editorClick(false)
      })
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      // this.editor = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData(function () {
        that.checkAllClick(that.checkedAll)
        // that.editorClick(that.editor)
      })
      // })
    },
    proDetail: function (items) {
      if (!this.editor) {
        this.$clickburiedPoint({
          url: 'ckysdatacenter/itemclick/save',
          data: {
            itemid: items.itemid,
            scenepoint: 'COLLECTITEM'
          }
        })
        this.$router.push({
          path: '/productdetail',
          query: {
            'itemid': items.itemid
          }
        })
      }
    },
    check: function (index) {
      // 再设置当前点击项选中
      this.checkbox = this.list[index].name
      // 设置值，以供传递
      this.list[index].isChecked = !this.list[index].isChecked
      var idxAll = 0
      var idxDel = 0
      this.list.forEach((item) => {
        if (!item.isChecked) {
          this.checkedAll = false
          idxDel++
        } else {
          this.deleteBool = true
          idxAll++
        }
      })
      if (idxAll === this.list.length) {
        this.checkedAll = true
      }
      if (idxDel === this.list.length) {
        this.deleteBool = false
      }
      this.isChooseProduct = this.list.filter(item => item.isChecked === true)
      // console.log(this.isChooseProduct)
    },
    editorClick: function (editor) {
      if (typeof (editor) === 'boolean') {
        this.editor = editor
      } else {
        this.editor = !this.editor
      }
      if (this.editor) {
        this.lisStyle = {
          marginRight: 0
        }
        this.$refs.content.map(item => item.style.marginLeft = 0)
        this.$refs.p.map(item => item.style.marginRight = '-0.74rem')
      } else {
        this.lisStyle = {
          marginRight: '0.11rem'
        }
      }
    },
    allCheck: function (check) {
      this.list.forEach(function (item) {
        item.isChecked = check
      })
      this.isChooseProduct = this.list.filter(item => item.isChecked === true)
      // console.log(this.isChooseProduct)
    },
    checkAllClick: function (checkAll) {
      if (typeof (checkAll) === 'boolean') {
        this.checkedAll = checkAll
      } else {
        this.checkedAll = !this.checkedAll
      }
      if (this.checkedAll) {
        this.allCheck(true)
        this.deleteBool = true
      } else {
        this.allCheck(false)
        this.deleteBool = false
      }
    },
    start: function (e, id) {
      this.x = e.targetTouches[0].pageX
    },
    move: function (e, id) {
      var change = e.targetTouches[0].pageX - this.x
      change = Math.min(Math.max(-100, change), 100)
      e.currentTarget.style.left = change + 'px'
    },
    end: function (e, id) {
      var left = parseInt(e.currentTarget.style.left)
      if (left < -50) {
        if (!this.editor) {
          e.currentTarget.style.marginLeft = '-0.74rem'
          this.$refs.p[id].style.marginRight = 0
          // $(e.currentTarget).find('.item-text').find('span').css('margin-right', '18px').parent().parent().css('margin-right', '60px')
        }
      } else if (left > 50) {
        e.currentTarget.style.marginLeft = 0
        this.$refs.p[id].style.marginRight = '-0.74rem'
      } else {
        e.currentTarget.style.marginLeft = 0
        this.$refs.p[id].style.marginRight = '-0.74rem'
      }
    },
    deleteClick: function (e, items, id) {
      var that = this
      var url = 'Wxmall/Collection/cancelCollection'
      var deleteProduct = {
        itemIds: [],
        itemIndex: []
      }
      deleteProduct.itemIds = []
      deleteProduct.itemIndex = []
      that.list.map(function (item, index) {
        if (item.isChecked) {
          deleteProduct.itemIds.push(item.itemid)
          deleteProduct.itemIndex.unshift(index)
        }
      })
      var data = {
        'itemids': ''
      }
      if (items) {
        data = {
          'itemids': items.itemid
        }
      } else {
        data = {
          'itemids': deleteProduct.itemIds.join()
        }
      }
      that.$dialog.confirm({
        message: '删除所选收藏商品？',
        className: 'collect_button_alert collection_button',
        cancelButtonColor: '#FC0324',
        confirmButtonColor: '#FFFCFC',
        confirmButtonText: '删除',
        closeOnPopstate: true
      }).then(function () {
        // on confirm
        customRequestAjax.post(url, data).then(res => {
          if (res.data.code === 200) {
            // console.log(that.list)
            if (items) {
              that.list.splice(id, 1)
              that.$refs.content[id].style.marginLeft = 0
              that.$refs.p[id].style.marginRight = '-0.74rem'
              that.getData(function () {
                that.checkAllClick(false)
                that.editorClick(false)
              })
            } else {
              deleteProduct.itemIndex.map(function (item, index) {
                that.list.splice(item, 1)
              })
              that.nowPage = 1
              that.list = []
              that.getData(function () {
                that.checkAllClick(false)
                that.editorClick(false)
              })
            }
          }
        })
      }).catch(function () {
        // on cancel
      })
    },
    stroll: function () {
      this.$router.push({
        path: '/classification',
        query: {
          type: 'inside'
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .collect {
    header {
      height: 0.38rem;
      background: #fff;
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      z-index: 10;
      p {
        float: right;
        font-size: 0.13rem;
        color: #191818;
        padding: 0.1rem 0.11rem;
      }
    }
    .my_scroller {
      padding-top: 0.38rem;
      padding-bottom: 0.44rem;
    }
    ul {
      .check {
        width: 0.31rem;
        input {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          -webkit-transform: translateY(-50%);
          -o-transform: translateY(-50%);
          -moz-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
        }
        label {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          -webkit-transform: translateY(-50%);
          -o-transform: translateY(-50%);
          -moz-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
        }
      }
      li {
        display: flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: -webkit-flex;
        margin: 0.1rem 0.11rem 0;
      }
      .liContent {
        /*flex-shrink: 0;*/
        display: flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: -webkit-flex;
        background: #fff;
        border-radius: 0.04rem;
        overflow: hidden;
        width: 100%;
        >p {
          font-size:0.14rem;
          color:#FFFFFF;
          width: 0.74rem;
          margin-right: -0.74rem;
          flex-shrink: 0;
          background:linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          background: -webkit-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          background: -moz-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          background: -ms-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          background: -o-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          border-radius:0px 4px 4px 0px;
          text-align: center;
          display: flex;
          display: -webkit-flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          justify-content: center;
          -webkit-justify-content: center;
          -moz-justify-content: center;
          -ms-justify-content: center;
          -o-justify-content: center;
          align-items: center;
          -webkit-align-items: center;
          -moz-align-items: center;
          -ms-align-items: center;
          -o-align-items: center;
        }
        .content{
          padding: 0.2rem 0.38rem 0.2rem 0.15rem;
          display: flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          display: -webkit-flex;
          width: 100%;
          img {
            width: 0.85rem;
            height: 0.85rem;
            flex-shrink: 0;
            -webkit-flex-shrink: 0;
            -o-flex-shrink: 0;
            -ms-flex-shrink: 0;
            -moz-flex-shrink: 0;
          }
          .detail {
            margin-left: 0.07rem;
            padding-top: 0.04rem;
            position: relative;
            p {
              /*height: 0.36rem;*/
              color:#292929;
              font-size: 0.13rem;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            b {
              font-weight: 400;
              display: block;
              margin-top: 0.05rem;
              margin-bottom: 0.04rem;
              font-size:0.11rem;
              color:#6C6C6C;
            }
            .nowPrice {
              font-size:0;
              display: block;
              color:#FC0324;
              position: absolute;
              bottom: 0;
              left:0;
              width: 100%;
              & sub {
                font-size:0.12rem;
                font-weight:400;
                vertical-align: baseline;
              }
              i {
                font-size: 0.14rem;
                font-style: normal;
                font-weight:700;
              }
              & sup {
                font-size:0.12rem;
                font-weight:400;
                vertical-align: baseline;
              }
            }
          }
        }

      }
    }
    .check {
      font-weight: 400;
      position: relative;
      i {
        display: block;
        width: 0.2rem;
        height: 0.2rem;
        /*float: left;*/
        margin-right: 0.05rem;
        background: url(../../assets/images/uncheck.png) no-repeat left top;
        background-size: 100% 100%;
      }
      input {
        display: block;
        float: left;
        position: absolute;
        width: 0.2rem;
        height: 0.2rem;
        left: 0;
        outline: none;
        -webkit-appearance: none;
        opacity: 0;
      }
      .on {
        background: url(../../assets/images/check.png) no-repeat left top;
        background-size: 100% 100%;
      }
      label {
        float: left;
        font-size: 0.12rem;
        color: #444;
        height: 0.2rem;
        display: flex;
        align-items: center;
      }
    }
    footer {
      height:0.44rem;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      padding-left: .12rem;
      padding-right: .11rem;
      /*padding: 0.09rem 0.11rem 0.08rem;*/
      /*border-top: 1px solid #BDBDBD;*/
      box-shadow:0 0.005rem 0 0.01rem rgba(0,0,0,0.25);
      -webkit-box-shadow: 0 0.005rem 0 0.01rem rgba(0,0,0,0.25);
      -moz-box-shadow: 0 0.005rem 0 0.01rem rgba(0,0,0,0.25);
      -o-box-shadow: 0 0.005rem 0 0.01rem rgba(0,0,0,0.25);
      -ms-box-shadew: 0 0.005rem 0 0.01rem rgba(0,0,0,0.25);
      display: flex;
      display: -webkit-flex;
      display: -o-flex;
      display: -ms-flex;
      display: -moz-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -o-justify-content: space-between;
      -moz-justify-content: space-between;
      -ms-justify-content: space-between;
      align-items: center;
      -webkit-align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      background: #fff;
      .check {
        margin: 0.13rem 0;
      }
      .clear {
        clear: both;
      }
      input {
        top: 0.06rem !important;
      }
      label {
        /*margin: 0.04rem 0 0.13rem 0 !important;*/
      }
      .btnDel {
        width:0.7rem;
        height:0.27rem;
        border-radius:0.14rem;
        border:1px solid rgba(184,190,200,1);
        font-size:0.12rem;
        font-weight:400;
        color:rgba(184,190,200,1);
        line-height:0.17rem;
        background: #fff;
        outline: none;
        &.delete {
          border:1px solid rgba(252,3,36,1);
          color:rgba(252,3,36,1);
        }
      }
    }
  }
  .empty {
    background: #fff;
    padding: 0.4rem 0 0.3rem;
    margin-bottom: 0.1rem;
    img {
      width:0.88rem;
      height:0.88rem;
      margin: 0 auto 0.15rem;
    }
    p {
      font-size:0.13rem;
      font-weight:400;
      color:rgba(41,41,41,1);
      line-height:0.18rem;
      text-align: center;
    }
  }
</style>
<style lang="scss">
  .collection_button {
    border-radius: 0.04rem;
    .van-dialog__content {
      .van-dialog__message {
        color: #333333;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/collection.vue